import { connect } from 'react-redux';
import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { api } from 'app/services';
import { successState, apiCallFailure } from 'app/actions';
import {
onlyCanAdminLocationOfWeChat } from
'../../app/reducers/role';
const SETTINGS_SECTIONS = [
{
  name: '欢迎屏幕',
  path: '' },

{
  name: '访客签到',
  path: 'sign_in' },

{
  name: '访客通知',
  path: 'notify' },

{
  name: '访客签退',
  path: 'sign_out' },

{
  name: '访客小程序',
  path: 'sign_procedure' },

{
  name: '自动审核',
  path: 'automatic_check' }];



const SETTING_WECHAT = [
{
  name: '欢迎屏幕',
  path: '' },

{
  name: '访客签到',
  path: 'sign_in' },

{
  name: '访客通知',
  path: 'notify' },

{
  name: '访客签退',
  path: 'sign_out' }];




var VisitSettingsBox = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.getVisitorSet = this.getVisitorSet.bind(this);this.updateVisitorSet = this.updateVisitorSet.bind(this);}getInitialState()
  {
    return {
      config: {},
      loading: true,
      loadFailed: false,
      loadErrorMessage: '' };

  }componentDidMount()

  {
    this.getVisitorSet();
  }getVisitorSet()

  {
    this.setState({
      loading: true,
      loadFailed: false,
      loadErrorMessage: '' });
    api.
    getVisitorSettings().
    then(
    ({ json }) => {
      const { config = {} } = json;
      this.setState({
        config,
        loadFailed: false });

    },
    error => {
      const { apiCallFailureAction } = this.props;
      const errorMessage = (error._error && error._error.message) ||
      error._error ||
      error.message ||
      '访客设置获取失败';
      this.setState({
        loadFailed: true,
        loadErrorMessage: errorMessage });
      apiCallFailureAction({
        status: 'error',
        message: errorMessage });
    }).

    finally(() => {
      this.setState({
        loading: false });

    });
  }updateVisitorSet(

  config) {
    const { successAction, apiCallFailureAction } = this.props;
    return api.updateVisitorSettings({ config }).then(
    ({ json }) => {
      const { config = {} } = json;
      this.setState({
        config });

      successAction({
        message: '操作成功' });

      return true;
    },
    error => {
      apiCallFailureAction({
        status: 'error',
        message: error._error || error.message || '' });

      return false;
    });

  }render()

  {
    const { setting_type, location_id, isOnlyWeChatManger } = this.props;
    const { config, loading, loadFailed, loadErrorMessage } = this.state;

    let menu = SETTINGS_SECTIONS;
    if (isOnlyWeChatManger) {
      menu = SETTING_WECHAT;
    }

    const childrenWithProps = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        config,
        updateVisitorSettings: this.updateVisitorSet,
        loading,
        loadFailed });

    });

    return (
      <div className={`clear-fix`} style={{ height: '100%' }}>
        <section className="kb-content" style={{ paddingTop: 0 }}>
          <nav className="nav-container f-left">
            <div className="nav-container-content">
              <header className="nav-header clear-fix">
                <h2 className="header-title f-left">访客设置</h2>
              </header>
              <div className="nav-body">
                <ul className="nav-container-list">
                  {menu.map((section, index) => {
                    let active = section.path === setting_type;
                    return (
                      <li
                      key={index}
                      className={classNames(
                      active ?
                      'nav-container-list-hover select-list-hover' :
                      '')}>


                        <Link
                        to={{
                          pathname: `/admin/locations/${location_id}/visit/settings/${section.path}` }}>


                          {' '}
                          {section.name}{' '}
                        </Link>
                      </li>);

                  })}
                </ul>
              </div>
            </div>
          </nav>
          {loadFailed ?
          <div className="nav-section-container f-right">
              <header className="nav-header">
                <div className="clear-fix">
                  <div className="nav-section-header-title f-left">
                    <span>访客设置</span>
                  </div>
                </div>
              </header>
              <div
              className="nav-section-content-container"
              style={{ minHeight: 500, paddingTop: 30 }}>

                <div className="kb-no-data">
                  <p>{loadErrorMessage || '访客设置加载失败，请重试'}</p>
                  <button
                  type="button"
                  className="certain-btn"
                  onClick={this.getVisitorSet}>
                    重试
                  </button>
                </div>
              </div>
            </div> :
          childrenWithProps}
        </section>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { params, location } = props;
  let location_id = params && params.id;
  const pathname = location ? location.pathname : '';
  const settingsPrefix = `/admin/locations/${location_id}/visit/settings`;
  const pathSettingType = pathname.indexOf(settingsPrefix) === 0 ?
  pathname.
  slice(settingsPrefix.length).
  replace(/^\/+|\/+$/g, '').
  split('/')[0] :
  '';
  let setting_type = pathSettingType;
  let isOnlyWeChatManger = onlyCanAdminLocationOfWeChat(state.user, location_id);
  return {
    location_id,
    setting_type,
    isOnlyWeChatManger };

}

function mapDispatchToProps(dispatch) {
  return {
    successAction: bindActionCreators(successState, dispatch),
    apiCallFailureAction: bindActionCreators(apiCallFailure, dispatch) };

}

export default connect(mapStateToProps, mapDispatchToProps)(VisitSettingsBox);
